import React, { useEffect, useState } from "react";
import BASEURL from "../../../Utils/Baseurl";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  Box,
  LinearProgress,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Add } from "@mui/icons-material";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import SalaryStructureInformationTable from "./components/SalaryStructureInformationTable";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useUserDetails } from "../../../../context/auth";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
const All_Component_Query = `
  query {
  allComponentmaster{
    id
    calculatedFrom
    calculatedIn
    componentName
  
    type
  

  }
}
`;

const { v4: uuidv4 } = require("uuid"); // Usedn ro generate uuid\

const AddSalaryStructure = () => {
  const { salaryview, setsalaryview, salaryedit, setsalaryedit, AccessData } =
    useUserDetails();
  const [Id, setId] = useState(null);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  // const {AccessData} = useUserDetails();
  const [update, setupdate] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [structureData, setStructureData] = useState({
    structureName: "",
    structureType: "",
    structureNameStatus: "",
    payrollFrequency: "",
    payrollFrequencyStatus: "",
  });

  const [originalComponentData, setOriginalComponentData] = useState(null);
  const [orginalearning, setorginalearning] = useState([]);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [earning, setEarning] = useState([
    {
      id: uuidv4(),
      state: "new",
    },
  ]);
  const [deduction, setDeduction] = useState([
    {
      id: uuidv4(),
      state: "new",
    },
  ]);
  const [benifits, setBenifits] = useState([
    {
      id: uuidv4(),
      state: "new",
    },
  ]);
  const [earningList, setEarningList] = useState([]);
  const [deductionList, setdeductionList] = useState([]);
  const [benefits, setbenefits] = useState([]);
  const [benefitsList, setbenefitsList] = useState([]);

  console.log("earningList:", earningList);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const ids = queryParams.get("id");
    setId(ids);
    if (ids) {
      getdata(ids);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const getdata = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `query GetSalaryStructureById($id: String!) {
      salaryStructuresById(id: $id) {
        id
        structureName
        salaryType
        components{
          componentName
          percentage
          amount
          type
        }
      }
    }`;

    try {
      const variables = { id };

      // Make the Axios POST request to the GraphQL API
      const response = await axios.post(BASEURL, {
        query,
        variables,
      });

      const alldata = response.data.data.salaryStructuresById.components;
      console.log("alldata:",alldata);

      const earning = alldata.filter((val) => val.type == "Earnings");
      const deductions = alldata.filter((val) => val.type == "Deductions");
      const benefits = alldata.filter((val) => val.type == "Benefits");
      console.log("earningearning:", earning);

      const earningdata = earning.map((data) => {
        return {
          ...data,
          id: uuidv4(),
          component: { value: data.componentName, label: data.componentName },
        };
      });
      const deductionsdata = deductions.map((data) => {
        return {
          ...data,
          id: uuidv4(),
          component: { value: data.componentName, label: data.componentName },
        };
      });
      const benefitsdata = benefits.map((data) => {
        return {
          ...data,
          id: uuidv4(),
          component: { value: data.componentName, label: data.componentName },
        };
      });

      console.log("earningdata:", earningList);

      setEarning(earningdata);
      // setEarningList(earning)
      setDeduction(deductionsdata);
      // setdeductionList(deductions)
      setBenifits(benefitsdata);
      // setbenefitsList(benefits)
      setStructureData({
        ...structureData,
        structureName: response.data.data.salaryStructuresById.structureName,
        structureType: response.data.data.salaryStructuresById.salaryType
      });

      setOriginalComponentData({
        ...originalComponentData,
        structureName: response.data.data.salaryStructuresById.structureName,
        salaryType: response.data.data.salaryStructuresById.salaryType
      });
      setorginalearning(earningdata);
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.log("eroroorr", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };


  const AddDeleteComponent = (id) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your component.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        confirmDeleteEarning(id);
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const confirmDeleteEarning = async(id) => {
    console.log("id:", id);
    console.log("earningList:", earningList);

    const query = `
    mutation deleteSalaryComponent($id: ID!) {
      deleteSalaryComponent(id: $id) {
        success
        message
      }
    }
  `;
  
  try {
    const response = await axios.post(BASEURL, {
      query: query,
      variables: {
        id: id,  // Ensure `id` is defined before using
      },
    });
  
    const responseData = response.data.data.deleteSalaryComponent?.success;
    console.log(responseData);

       if (responseData) {
           
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Component Deleted Successfully!",
              showConfirmButton: false,
              timer: 2500,
            });
          } else {
            console.log("Error deleting WFH:", responseData.data.deleteWFH.message);
          }

  } catch (error) {
    console.error("Error deleting salary component:", error);
  }
  

    // Find the matching earning entry
    let data = earning.find((val) => val.id === id);
    console.log("data:", data);

    // Update earningList by filtering out the matching entry
    setEarningList(
      earningList.filter((val) => val.componentName !== data?.componentName)
    );


    // Update earning state by filtering out the matching entry
    setEarning(earning.filter((earn) => earn.id !== id));
  };

  console.log("earningList:", earning);

  const confirmDeleteDeduction = (id) => {
    setDeduction(deduction.filter((earn) => earn.id !== id));
  };
  const confirmDeleteBenifits = (id) => {
    setBenifits(benifits.filter((earn) => earn.id !== id));
  };

  const onAddEarning = () => {
    if (
      earning.length <
      earningList.filter(
        (component) =>
          !benifits.some(
            (val) => val.component?.value === component.componentName
          )
      ).length
    ) {
      setEarning([
        ...earning,
        {
          id: uuidv4(),
          state: "new",
        },
      ]);
    }
  };
  const onAddDeduction = () => {
    if (deduction.length < deductionList.length) {
      setDeduction([
        ...deduction,
        {
          id: uuidv4(),
          state: "new",
        },
      ]);
    }
  };
  const onAddBenifits = () => {
    // if (
    //   benifits.length <
    //   benefits.filter(
    //     (component) =>
    //       !earning.some(
    //         (val) => val.component?.value === component.componentName
    //       )
    //   ).length
    // ) {
    //   setBenifits([
    //     ...benifits,
    //     {
    //       id: uuidv4(),
    //       state: "new",
    //     },
    //   ]);
    // }
    if (benifits.length < benefitsList.length) {
      setBenifits([
        ...benifits,
        {
          id: uuidv4(),
          state: "new",
        },
      ]);
    }
  };

  const onDataChange = (component, e, earn, type) => {
    if (component === "amount") {
      //Set the minimum value of the selected option
      if (type === "Earning") {
        const newEarning = earning.map((item) => {
          if (item.id === earn) {
            if (/^\d*$/.test(e)) {
              item.amount = e;
            }
          }
          return item;
        });
        setEarning(newEarning);
      } else if (type === "Deduction") {
        const newDeduction = deduction.map((item) => {
          if (item.id === earn) {
            if (/^\d*$/.test(e)) {
              item.amount = e;
            }
          }
          return item;
        });
        setDeduction(newDeduction);
      } else if (type === "Benifits") {
        const newBenifits = benifits.map((item) => {
          if (item.id === earn) {
            if (/^\d*$/.test(e)) {
              item.amount = e;
            }
          }
          return item;
        });
        setBenifits(newBenifits);
      }
    } else if (component === "percentage") {
      if (type === "Earning") {
        const newEarning = earning.map((item) => {
          if (item.id === earn) {
            // Check for empty string or valid percentage with decimals
            if (e === "" || (/^\d*\.?\d*$/.test(e) && parseFloat(e) <= 100)) {
              item.percentage = e;
            }
          }
          return item;
        });
        setEarning(newEarning);
      } else if (type === "Deduction") {
        const newDeduction = deduction.map((item) => {
          if (item.id === earn) {
            // Same validation logic, fixed condition to match valid percentage
            if (e === "" || (/^\d*\.?\d*$/.test(e) && parseFloat(e) <= 100)) {
              item.percentage = e;
            }
          }
          return item;
        });
        setDeduction(newDeduction);
      } else if (type === "Benifits") {
        const newBenifits = benifits.map((item) => {
          if (item.id === earn) {
            if (e === "" || (/^\d*\.?\d*$/.test(e) && parseFloat(e) <= 100)) {
              item.percentage = e;
            }
          }
          return item;
        });
        setBenifits(newBenifits);
      }
    } else if (component === "component") {
      //Set the unit price of the selected option
      if (type === "Earning") {
        const newEarning = earning.map((item) => {
          if (item.id === earn) {
            item.component = e;
            item.componentId = data.find(
              (val) => val.componentName === e?.value
            )?.id;
            item.amount = "";
            item.percentage = "";
            item["structureType"] = type;
          }
          return item;
        });
        console.log("newEarning", newEarning);
        setEarning(newEarning);
      } else if (type === "Deduction") {
        const newDeduction = deduction.map((item) => {
          if (item.id === earn) {
            item.component = e;
            item.amount = "";
            item.percentage = "";
            item.componentId = data.find(
              (val) => val.componentName === e?.value
            )?.id;
            item["structureType"] = type;
          }
          return item;
        });
        setDeduction(newDeduction);
      } else if (type === "Benifits") {
        const newBenifits = benifits.map((item) => {
          if (item.id === earn) {
            item.component = e;
            item.amount = "";
            item.percentage = "";
            item.componentId = data.find(
              (val) => val.componentName === e?.value
            )?.id;
            item["structureType"] = type;
          }
          return item;
        });
        setBenifits(newBenifits);
      }
    }
  };

  const payrollOptions = [
    { value: "15 Days", label: "15 Days" },
    { value: "30 Days", label: "30 Days" },
    { value: "60 Days", label: "60 Days" },
  ];

  const fetchComponents = async () => {
    const response = await fetch(BASEURL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: All_Component_Query }),
    });
    const data = await response.json();
    console.log("datassss:", data);

    if (data.errors) {
      throw new Error(data.errors[0].message);
    }
    return data.data.allComponentmaster;
  };

  useEffect((_) => {
    const fetchData = async () => {
      try {
        const details = await fetchComponents(); // Await for the data
        console.log("detailsdetails:", details);

        // Filtering based on 'type' field

        const earningDetails = details.filter((val) => val.type === "Earnings");
        const deductionDetails = details.filter(
          (val) => val.type === "Deductions"
        );
        const benefits = details.filter((val) => val.type === "Benefits");
        console.log("earningDetails ", earningDetails);
        console.log("deductionDetails ", deductionDetails);
        setEarningList(earningDetails);
        setdeductionList(deductionDetails);
        setbenefitsList(benefits);
        setData(details);
      } catch (error) {
        console.error("Error fetching components: ", error);
      }
    };

    fetchData();
  }, []);

  console.log("earningList:", earningList);

  const handleStructureDataChange = (event, selectEvent) => {
  let structureState = { ...structureData };

  if (event?.target === undefined && selectEvent) {
    if (selectEvent.name === "payrollFrequency") {
      const lengthRegex = new RegExp("^[A-Za-z 0-9]");

      if (lengthRegex.test(event?.label) === true) {
        structureState[selectEvent.name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
      } else {
        structureState[selectEvent.name + "Status"] =
          selectEvent.value === "" ? "unchecked" : "error";
      }
    }

    structureState[selectEvent.name] = event;
  } else {
    const changeAllowed = true;

    switch (event.target.name) {
      case "structureName":
        {
          const lengthRegex = /^([a-z A-Z]{1,20})$/;

          if (lengthRegex.test(event.target.value) === true) {
            structureState.structureNameStatus = "success";
          } else {
            structureState.structureNameStatus =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;

      default:
        break;
    }

    if (changeAllowed) {
      if (
        event.target.name === "structureType" &&
        structureData.structureType &&
        structureData.structureType !== event.target.value
      ) {
        setEarning([]);
        setDeduction([]);
        setBenifits([]);
      }

      structureState[event.target.name] = event.target.value;
    }
  }

  setStructureData({ ...structureState });
};

  const handleAddComponent = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onComponentSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onComponentSubmit = async () => {

    const query = ` mutation CreateSalaryStructure(
        $structureName: String!,
        $salaryType: String,
        $components: [SalaryComponentInput!]!
      ) {
        createSalaryStructure(
          structureName: $structureName
          salaryType: $salaryType
          components: $components
        ) {
          salaryStructure {
            id
            structureName
          }
          createdComponents {
            id
            percentage
            amount
            type
          }
        }
      }
    `;

    const allComponents = [...earning, ...benifits, ...deduction];

    console.log("allComponents:", allComponents);

    if (structureData.structureNameStatus === "success") {
      try {
        const componentsPayload = allComponents
          .filter((component) => component.componentId)
          .map((component) => ({
            componentMasterId: component.componentId,
            percentage: component.percentage
              ? String(component.percentage)
              : null,
            amount: component.amount ? String(component.amount) : null,
            type: component.structureType || "null",
          }));

        const variables = {
          structureName: structureData.structureName,
          salaryType: structureData.structureType || "null",
          components: componentsPayload,
        };

        console.log("variables:", variables);

        const response = await axios.post(BASEURL, {
          query,
          variables,
        });

        console.log("Response Data:", response.data);
        const result = response.data.data.createSalaryStructure.salaryStructure;
        if (result !== "") {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Salary Structure Submitted Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          navigate("/salary-structure");
        }
        //  navigate("/salary-structure");
        // Navigate to the salary structure page
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      } catch (error) {
        console.error("Error in API response:", error);
        setConfirmationDialog({
          open: true,
          title: "Error message",
          message:
            "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
          showCancel: true,
          showConfirm: false,
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
    } else {
      // Handle input validation errors
      console.log("error2");
      if (
        structureData.structureNameStatus === "" ||
        structureData.structureNameStatus === "unchecked"
      ) {
        setStructureData({
          ...structureData,
          structureNameStatus: "uncheckedError",
        });
      } else if (
        structureData.payrollFrequencyStatus === "" ||
        structureData.payrollFrequencyStatus === "unchecked"
      ) {
        setStructureData({
          ...structureData,
          payrollFrequencyStatus: "uncheckedError",
        });
      }
    }
  };

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: true,
  });

  const toggleEdit = () => {
    setsalaryedit(false);
    setupdate(true);
  };

  const onEditSalarySubmit = async () => {
    console.log("earningList:", earningList);

    const query = `mutation UpdateSalaryStructure(
      $structureId: ID!
      $structureName: String!
      $salaryType: String
      $components: [SalaryComponentInput!]!
    ) {
      updateSalaryStructure(
        structureId: $structureId
        structureName: $structureName
        salaryType: $salaryType
        components: $components
      ) {
        salaryStructure {
          id
          structureName
          salaryType
        }
      }
    }`;

    const allComponents = [...earning, ...benifits, ...deduction];
    console.log("allComponents:", allComponents);

    const alllist = [...earningList, ...deductionList, ...benefitsList];
    console.log("alllist:", alllist);

    const filteredList = alllist.filter((item) =>
      allComponents.some(
        (component) => component.componentName === item.componentName
      )
    );
    console.log("filteredList:", filteredList);

    const updatedComponents = allComponents.map((component) => {
      const matchingItem = filteredList.find(
        (item) => item.componentName === component.componentName
      );
      return {
        ...component,
        id: matchingItem ? matchingItem.id : component.id,
      };
    });

    console.log("updatedComponents:", updatedComponents);

    try {
      const componentsPayload = updatedComponents.map((component) => ({
        componentMasterId: component.id,
        // componentName:component.componentName,
        percentage: component.percentage ? String(component.percentage) : null,
        amount: component.amount ? String(component.amount) : null,
        type: component.type ? component.type : component.structureType,
      }));

      const variables = {
        structureId: Id,
        structureName: structureData.structureName,
        salaryType: structureData.structureType || "null",
        components: componentsPayload,
      };

      console.log("variables:", variables);

      const response = await axios.post(BASEURL, {
        query,
        variables,
      });

      const result = response.data.data.updateSalaryStructure?.salaryStructure;
      if (result !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Salary Structure Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/salary-structure");
      }

      console.log("response:", response.data); // Log response for debugging
    } catch (error) {
      console.error("Error updating salary structure:", error); // Better error handling
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ondeleteSalary();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ondeleteSalary = async () => {
    const query = `
  mutation deleteSalaryStructure($structureId: ID!) {
  deleteSalaryStructure(structureId: $structureId) {
    success
    
  }
}

`;

    console.log("IDDDDD:", Id);

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          structureId: Id, // Ensure `id` is defined in the component's scope
        },
      });

      const result = response.data.data.deleteSalaryStructure;

      console.log("result:", result);

      if (result.success) {
        navigate("/salary-structure");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Salary Structure Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        console.log("Error deleting Shift:", result.message || "Unknown error");
      }
    } catch (error) {
      console.error("An error occurred while deleting the Shift:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (structureData.structureNameStatus === "success" &&
      structureData.structureType !== ""
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const onDiscardDesignation = () => {
    if (originalComponentData) {
      setStructureData(originalComponentData);
    }
    if (orginalearning) {
      setEarning(orginalearning);
    }
    setsalaryedit(true);
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/salary-structure");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the salary structure details for you. This may
                    take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card sx={{ overflow: "visible" }}>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                {!salaryview && (
                     <Stack direction="column" spacing={0}>
                     <MaterialTypography variant="h5" fontWeight="medium">
                       Add Salary Structure Details
                     </MaterialTypography>
                   </Stack>
                )}
                {salaryview && (
                    <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                       Salary Structure Details
                    </MaterialTypography>
                  </Stack>
                )}
                {AccessData &&
                  Array.isArray(AccessData) &&
                  AccessData.some(
                    (item) =>
                      item.component === "EditSalaryStructure" &&
                      item.can_access
                  ) && (
                    <ButtonGroup variant="outlined" aria-label="button group">
                      {salaryview && (
                        <>
                          <ButtonGroup
                            variant="outlined"
                            aria-label="Loading button group"
                          >
                            <MaterialButton
                              variant="gradient"
                              color="dark"
                              onClick={toggleEdit}
                              startIcon={<EditIcon />}
                            >
                              Edit
                            </MaterialButton>
                            {/* Uncomment to enable delete functionality */}

                            <MaterialButton
                              variant="gradient"
                              color="dark"
                              onClick={AddDelete}
                              startIcon={<DeleteIcon />}
                            >
                              Delete
                            </MaterialButton>
                          </ButtonGroup>
                        </>
                      )}
                    </ButtonGroup>
                  )}
              </Stack>
            }
        
          />
          <CardContent sx={{ minHeight: "60vh" }}>
            <MaterialBox>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12, sm: 8 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Structure Name <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="structureName"
                    placeholder="Eg. HRA"
                    value={structureData.structureName}
                    onChange={handleStructureDataChange}
                    disabled={salaryedit === true ? true : false}
                    error={
                      structureData.structureNameStatus === "error" ||
                      structureData.structureNameStatus === "uncheckedError"
                        ? true
                        : false
                    }
                    success={
                      structureData.structureNameStatus === "success"
                        ? true
                        : false
                    }
                  />
                  {structureData.structureNameStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Sturcture Name should be maximum 20 characters long and
                        can contain only alphabets
                      </FormHelperText>
                    </FormControl>
                  )}
                  {structureData.structureNameStatus === "uncheckedError" && (
                    <FormControl error>
                      <FormHelperText>
                        Sturcture Name is required
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid>
                <Grid size={{ xs: 12, sm: 5 }}>
                  <MaterialBox>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      sx={{ fontSize: "0.8rem" }}
                    >
                      Salary Type <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>

                    <FormControl fullWidth>
                      <RadioGroup
                        name="structureType"
                        value={structureData.structureType || ""}
                        onChange={handleStructureDataChange}
                        sx={{ gap: 0.5 }}
                      >
                        <Box>
                          <FormControlLabel
                            value="TYPE_ONE"                            
                            disabled={salaryedit}
                            control={<Radio size="small" />}
                            label="Type 1"
                            sx={{
                              m: 0,
                              "& .MuiFormControlLabel-label": {
                                fontSize: "0.85rem",
                              },
                            }}
                          />
                          <MaterialTypography
                            variant="caption"
                            sx={{
                              display: "block",
                              ml: 4,
                              mt: -0.5,
                              fontSize: "0.7rem",
                              color: "text.secondary",
                            }}
                          >
                            Keelis Template with Earnings, Deductions and Benefits
                          </MaterialTypography>
                        </Box>

                        <Box>
                          <FormControlLabel
                            value="TYPE_TWO"
                            disabled={salaryedit}
                            control={<Radio size="small" />}
                            label="Type 2"
                            sx={{
                              m: 0,
                              "& .MuiFormControlLabel-label": {
                                fontSize: "0.85rem",
                              },
                            }}
                          />
                          <MaterialTypography
                            variant="caption"
                            sx={{
                              display: "block",
                              ml: 4,
                              mt: -0.5,
                              fontSize: "0.7rem",
                              color: "text.secondary",
                            }}
                          >
                            Everguard Template with Deduction component only
                          </MaterialTypography>
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
            {structureData?.structureType !== "TYPE_TWO" && (
            <MaterialBox>
              <MaterialTypography
                sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
                variant="h5"
                fontWeight="bold"
              >
                Earning
              </MaterialTypography>
              <SalaryStructureInformationTable
                tableData={earning}
                confirmDelete={AddDeleteComponent}
                onAddRow={onAddEarning}
                onDataChange={onDataChange}
                edit={salaryedit}
                // componentList={earningList.filter(
                //   (component) =>
                //     !benifits.some(
                //       (val) => val.component?.value === component.componentName
                //     )
                // )}
                componentList={earningList}
                salaryedit={salaryedit}
                type="Earning"
              />
              <MaterialButton
                variant="gradient"
                color="dark"
                disabled={salaryedit === true ? true : false}
                startIcon={<Add />}
                onClick={() => {
                  onAddEarning();
                }}
                mb={0}
                pb={0}
              >
                Add
              </MaterialButton>
            </MaterialBox>
            )}
            <MaterialBox>
              <MaterialTypography
                sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
                variant="h5"
                fontWeight="bold"
              >
                Deduction
              </MaterialTypography>
              <SalaryStructureInformationTable
                tableData={deduction}
                confirmDelete={confirmDeleteDeduction}
                onAddRow={onAddDeduction}
                onDataChange={onDataChange}
                componentList={deductionList}
                salaryedit={salaryedit}
                type="Deduction"
              />
              <MaterialButton
                variant="gradient"
                color="dark"
                startIcon={<Add />}
                disabled={salaryedit === true ? true : false}
                onClick={() => {
                  onAddDeduction();
                }}
                mb={0}
                pb={0}
              >
                Add
              </MaterialButton>
            </MaterialBox>
            {structureData?.structureType !== "TYPE_TWO" && (
            <MaterialBox>
              <MaterialTypography
                sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
                variant="h5"
                fontWeight="bold"
              >
                Benefits
              </MaterialTypography>
              <SalaryStructureInformationTable
                tableData={benifits}
                confirmDelete={confirmDeleteBenifits}
                onAddRow={onAddBenifits}
                onDataChange={onDataChange}
                salaryedit={salaryedit}
                componentList={benefitsList}
                type="Benifits"
              />
              <MaterialButton
                variant="gradient"
                color="dark"
                startIcon={<Add />}
                disabled={salaryedit === true ? true : false}
                onClick={() => {
                  onAddBenifits();
                }}
                mb={0}
                pb={0}
              >
                Add
              </MaterialButton>
            </MaterialBox>
            )}
          </CardContent>
        
            <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            >
              {!salaryview && (
                <>
                 <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handlecancel}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleAddComponent}
                >
                  submit
                </MaterialButton>
                </>
              )}

              {update && (
                <>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={onDiscardDesignation}
                  >
                    Discard
                  </MaterialButton>

                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    //  disabled={
                    //      !checkFields()
                    //  }

                    onClick={onEditSalarySubmit}
                  >
                    Update
                  </MaterialButton>
                </>
              )}
            </MaterialBox>
          
        </Card>
      )}
    </DashboardLayout>
  );
};

export default AddSalaryStructure;
